import React, { FC, ChangeEvent, ReactNode, useContext } from "react";
import { Collapse, FormControl, FormControlLabel, FormLabel, RadioGroup } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { FiltersContext, VisibilityContext } from "../../context";
import { FILTERS } from "../../constants";
import StyledRadio from "../Common/StyledRadio";

const useStyles = makeStyles({
  radioGroup: {
    paddingLeft: "3px",
  },
});

interface RadiosProps {
  icon?: ReactNode;
  section: string;
  label?: string;
  visibilitySection: string;
}

const Radios: FC<RadiosProps> = ({ icon, section, label, visibilitySection }) => {
  const classes = useStyles();

  const [filtersContext, setFiltersContext] = useContext(FiltersContext);
  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectAllRadios = event.target.value === "All";
    const filters = selectAllRadios ? [] : [event.target.value];

    setFiltersContext({
      ...filtersContext,
      [section]: filters,
    });
  };

  return (
    <Collapse in={visibilityContext[visibilitySection]}>
      <FormControl component="fieldset" margin="dense">
        {label && <FormLabel component="legend">{label}</FormLabel>}
        <RadioGroup
          className={classes.radioGroup}
          aria-label={label}
          name={section}
          value={filtersContext[section][0] || "All"}
          onChange={(event) => handleChange(event)}
        >
          <FormControlLabel key="All" value="All" control={<StyledRadio />} label="All" />
          {FILTERS.OPTIONS[section].map((option) => (
            <FormControlLabel key={option} value={option} control={<StyledRadio />} label={option} />
          ))}
        </RadioGroup>
      </FormControl>
    </Collapse>
  );
};

export default Radios;
